import InvoicesScreen from './InvoicesScreen';

export default InvoicesScreen;
